/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Sahini Sai Charan",
  title: "Hello, I'm Sai Charan",
  subTitle: emoji(
    // "A passionate DevOps and Cloud Engineer 🚀 with hands-on experience in automating infrastructure, orchestrating CI/CD pipelines, and integrating AI tools to optimize developer workflows. Skilled in Terraform, Kubernetes, and AI integrated DevOps workflows — I build scalable systems that think, adapt, and deliver."
    "Dynamic Cloud & DevOps Leader 🌐 with nearly a decade of experience driving cloud transformation, infrastructure automation, and system reliability across AWS, Azure, and GCP. Skilled in Terraform, Kubernetes, and AI‑integrated DevOps workflows, I specialize in building scalable, secure, and resilient systems. Passionate about embedding security into CI/CD, orchestrating multi‑cloud environments, and leveraging AI tools to accelerate delivery and optimize performance."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1GXF2Sqg6d-vZ-PWyTNi0NvqPKVwDUUwK/view?usp=share_link", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/Sahini-Sai-Charan/Projects",
  linkedin: "https://www.linkedin.com/in/sai-charan-sahini/",
  gmail: "saicharan.sahini@gmail.com",
  // gitlab: "https://gitlab.com/saadpasta",
  // facebook: "https://www.facebook.com/saad.pasta7",
  // medium: "https://medium.com/@saadpasta",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // // Instagram, Twitter and Kaggle are also supported in the links!
  // // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "Design and implement scalable cloud infrastructure, automate devops workflows, and integrate AI-driven systems to enhance reliability, performance, and developer productivity.",
  skills: [
    emoji(
      "⚡ Automate and optimize CI/CD pipelines, enabling faster, more reliable software delivery across diverse environments"
    ),
    emoji("⚡ Design and manage scalable, secure cloud architectures using Infrastructure as Code and best-in-class provisioning strategies"),
    emoji(
      "⚡ Integrate AI tools into DevOps workflows to enhance observability, predict failures, and accelerate decision-making across the deployment lifecycle"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

// ...existing code...
// ...existing code...
softwareSkills: [
  // Languages
  {
    skillName: "Java",
    fontAwesomeClassname: "fab fa-java"
  },
  {
    skillName: "Python",
    fontAwesomeClassname: "fab fa-python"
  },
  {
    skillName: "Bash",
    fontAwesomeClassname: "fas fa-terminal"
  },
  {
    skillName: "SQL",
    fontAwesomeClassname: "fas fa-database"
  },
  // Cloud Platforms
  {
    skillName: "Azure",
    fontAwesomeClassname: "fab fa-microsoft"
  },
  {
    skillName: "AWS",
    fontAwesomeClassname: "fab fa-aws"
  },
  {
    skillName: "Google Cloud",
    fontAwesomeClassname: "fab fa-google"
  },
  // Containers & Orchestration
  {
    skillName: "Docker",
    fontAwesomeClassname: "fab fa-docker"
  },
  {
    skillName: "Kubernetes",
    fontAwesomeClassname: "fas fa-server"
  },
  {
    skillName: "Helm",
    fontAwesomeClassname: "fas fa-ship"
  },
  // DevOps & IaC Tools
  {
    skillName: "Terraform",
    fontAwesomeClassname: "fas fa-cubes"
  },
  {
    skillName: "Ansible",
    fontAwesomeClassname: "fas fa-robot"
  },
  {
    skillName: "Jenkins",
    fontAwesomeClassname: "fas fa-stream"
  },
  {
    skillName: "Azure DevOps",
    fontAwesomeClassname: "fab fa-microsoft"
  },
  {
    skillName: "Git",
    fontAwesomeClassname: "fab fa-git-alt"
  },
  // Monitoring & Observability
  {
    skillName: "Prometheus",
    fontAwesomeClassname: "fas fa-chart-line"
  },
  {
    skillName: "Grafana",
    fontAwesomeClassname: "fas fa-tachometer-alt"
  },
  // Security & Code Quality
  {
    skillName: "SonarQube",
    fontAwesomeClassname: "fas fa-bug"
  },
  {
    skillName: "Trivy",
    fontAwesomeClassname: "fas fa-shield-alt"
  },
  {
    skillName: "Black Duck",
    fontAwesomeClassname: "fas fa-shield-alt"
  },
  // AI & Productivity Tools
  {
    skillName: "GitHub Copilot",
    fontAwesomeClassname: "fas fa-robot"
  },
  {
    skillName: "Devin AI",
    fontAwesomeClassname: "fas fa-robot"
  },
  {
    skillName: "Cursor AI",
    fontAwesomeClassname: "fas fa-code"
  },
  {
    skillName: "Windsurf AI",
    fontAwesomeClassname: "fas fa-wind"
  },
  // Linux & Administration
  {
    skillName: "Linux",
    fontAwesomeClassname: "fab fa-linux"
  },
  {
    skillName: "Databases",
    fontAwesomeClassname: "fas fa-database"
  },
  // Project Management & Collaboration
  {
    skillName: "Jira",
    fontAwesomeClassname: "fas fa-tasks"
  },
  {
    skillName: "ServiceNow",
    fontAwesomeClassname: "fas fa-cog"
  }
],
// ...existing code...
// ...existing code...
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Anil Neerukonda Institute of Technology and Sciences",
      logo: require("./assets/images/harvardLogo.png"),
      subHeader: "Bachelors in Information Technology",
      duration: "September 2012 - April 2016",
      descBullets: [
        "Developed a scalable e-commerce platform using .NET, showcasing end-to-end architecture, secure transactions, and modular design",
        "Collaborated with our Head of Department on his PhD research by conducting a comprehensive analysis of the “Comparative Study of Shuffled Frog Leaping and Modified Shuffled Frog Leaping Algorithms with Data Clustering,” contributing to algorithmic evaluation, performance benchmarking, and clustering accuracy insights as our final year project"]
    },
    {
      schoolName: "Sri Chaitanya Junior College",
      logo: require("./assets/images/stanfordLogo.png"),
      subHeader: "Specialized in Science and Mathematics",
      duration: "June 2010 - March 2012",
      desc: "Ranked top 10% in the program",
      descBullets: [
        "Completed higher secondary education with a strong foundation in Mathematics, Physics, and Chemistry, fostering analytical thinking and problem-solving skills",
        "Developed a deep understanding of scientific principles and quantitative reasoning, laying the groundwork for future pursuits in engineering and technology."]
  
    },
   {
      schoolName: "Geetanjali Public School",
      logo: require("./assets/images/stanfordLogo.png"),
      subHeader: "",
      duration: "June 2000 - March 2010",
      desc: "Completed foundational schooling from Kindergarten to 10th Standard with a consistent focus on academic excellence and holistic development",
      descBullets: [
        "Built a strong base in core subjects including mathematics, science, and language, fostering curiosity and critical thinking from an early age.",  
        "Actively participated in school activities and projects, developing teamwork, communication, and leadership skills.Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

// ...existing code...
const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "CI/CD",
      progressPercentage: "100%"
    },
    {
      Stack: "Docker & Kubernetes",
      progressPercentage: "90%"
    },   
    {
      Stack: "Terraform",
      progressPercentage: "90%"
    }, 
    {
      Stack: "Helm",
      progressPercentage: "75%"
    },
    {
      Stack: "Ansible",
      progressPercentage: "70%"
    },  
    {
      Stack: "Git",
      progressPercentage: "95%"
    },  
    {
      Stack: "Azure",
      progressPercentage: "80%"
    },
    {
      Stack: "AWS",
      progressPercentage: "80%"
    },
    {
      Stack: "Google Cloud Platform",
      progressPercentage: "80%"
    },
    {
      Stack: "Linux",
      progressPercentage: "95%"
    },
    {
      Stack: "Python",
      progressPercentage: "80%"
    },
    {
      Stack: "Prometheus & Grafana",
      progressPercentage: "75%"
    },
    {
      Stack: "SonarQube",
      progressPercentage: "90%"
    },
    {
      Stack: "ELK Stack",
      progressPercentage: "70%"
    },
    {
      Stack: "Java",
      progressPercentage: "80%"
    },
    {
      Stack: "Databases",
      progressPercentage: "80%"
    },
    {
      Stack: "GitHub Copilot",
      progressPercentage: "85%"
    },
    {
      Stack: "AIDE",
      progressPercentage: "90%"
    },
  ],
  displayCodersrank: false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Technology Lead",
      company: "ValueLabs",
      companylogo: require("./assets/images/valuelabs-logo.png"),
      date: "December 2024 – Present",
      // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Orchestrated containerized microservice deployments using Docker and Kubernetes, while automating legacy IIS workloads via Azure Pipelines for streamlined delivery.",  
        "Provisioned and managed scalable multi-cloud infrastructure using Terraform, with secure CI/CD integration powered by Azure Key Vault for secret management.",
        "Accelerated DevOps workflows by integrating AiDE and GitHub Copilot, embedding AI-driven automation into CI/CD, infrastructure provisioning, and container orchestration."]
    },
    {
      role: "Senior Software Engineer",
      company: "Excelra Knowledge Solutions Pvt Ltd",
      companylogo: require("./assets/images/excelra-logo.jpg"),
      date: "June 2021 – November 2024",
      // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
      descBullets: [
        "Built and maintained cloud-native CI/CD workflows using Azure DevOps, GCP Cloud Build, and Jenkins, enabling consistent and scalable delivery across multi-cloud environments.",
        "Led infrastructure automation using Terraform and Helm, while managing secure Kubernetes deployments and integrating SonarQube, Prometheus, and Grafana for observability.",
        "Adopted DevSecOps practices to secure microservices via Azure API Management and conducted vulnerability assessments to ensure compliance across cloud and on-prem systems."]
    },
    {
      role: "Technology Analyst",
      company: "Infosys Ltd",
      companylogo: require("./assets/images/infosys-logo.png"),
      date: "May 2016 – June 2021",
      // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
      descBullets: [
        "Served as SME for client reporting systems in the financial domain, ensuring high availability, compliance, and operational resilience.",
        "Automated microservice releases using Jenkins, Ansible, and GitOps workflows, while managing AWS IAM, Linux servers, and optimizing system performance through RCA.",
        "Led technical mentorship initiatives and implemented monitoring solutions with ELK and ServiceNow, integrating serverless patterns via AWS Lambda for scalable, event-driven deployments."]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "Projects that I have worked on which has created an impact to the users and clients",
  projects: [
    {
      image: require("./assets/images/update-in-progress.jpg"),
      projectName: "Update in Progress",
      projectDesc: "Update in Progress",
      // footerLink: [
      //   {
      //     name: "Visit Website",
      //     url: "http://saayahealth.com/"
      //   }
        //  you can add extra buttons here.
      //]
    },
    {
      image: require("./assets/images/update-in-progress.jpg"),
      projectName: "Update in Progress",
      projectDesc: "Update in Progress",
      // footerLink: [
      //   {
      //     name: "Visit Website",
      //     url: "http://nextu.se/"
      //   }
      // ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Java SE 8 Programmer 1",
      subtitle:
        "Certified as a Java SE 8 Programmer I, demonstrating proficiency in core Java programming and object-oriented design principles.",
      image: require("./assets/images/java-se8-logo.png"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://drive.google.com/file/d/1go--R7Hq8rk4hy-tIZ4cf0uCFMNgs971/view?usp=share_link"
        },
    ]
  },
  {
    title: "Data Engineering",
    subtitle:
      "Advanced certification in Data Engineering, demonstrating expertise in data pipeline architecture, ETL/ELT processes, and scalable data solutions",
    image: require("./assets/images/Data-Engineering.png"),
    imageAlt: "Data Engineering Logo",
    footerLink: [
      {
        name: "View Certificate",
        url: "https://scaler-certificates.s3.amazonaws.com/certificates/Academy/MODULE_CERTIFICATE/ACAD-2026-10564.png?AWSAccessKeyId=AKIAY7MGLG6ZDQZCIEUY&Signature=goGY3%2BSdgHo4EJ%2FubxImCD%2FokxM%3D&Expires=1775190914"
      }
    ]
  },

  {
    title: "Devin AI Foundations",
    subtitle: "Certified in Devin AI Foundations, mastering AI-driven autonomous software development, intelligent code generation, and enterprise AI integration",
    image: require("./assets/images/Devin.jpeg"),
    imageAlt: "Devin AI Foundations Logo",
    footerLink: [
      {
        name: "View Certificate",
        url: "https://learn.devinenterprise.com/certificates/4d42859e-a272-4547-b2be-0f8d233c2bad"
      }
    ]
  }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "Learn with me and explore some of my personal blog posts",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://devopscube.com/list-of-devops-blogs-and-resources/",
      title: "Joining DevOps? This is for you…",
      description:
        "Curated for newcomers, this blog covers foundational DevOps concepts, tools, and cultural practices."
    },
    {
      url: "https://www.geeksforgeeks.org/blogs/devops-projects/",
      title: "Ready to build? Level up with real DevOps projects…",
      description:
        "Offers hands-on projects like CI/CD pipelines, container orchestration, and monitoring setups — ideal for building real-world experience."
    },
    {
      url: "https://www.diffblue.com/resources/best-devops-blogs-2025/",
      title: "Already in the game? Stay sharp with expert DevOps insights…",
      description:
        "Curates high-level insights from industry leaders on platform engineering, observability, and scaling DevOps in enterprise environments."
    }    
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const linkedinRecommendations = {
  title: "LINKEDIN RECOMMENDATIONS",
  subtitle: emoji("What my colleagues say about my work 💬"),
  recommendations: [
    {
      name: "Sandeep Palaparti",
      role: "Project Manager at Infosys Ltd",
      recommendation: "I had the pleasure of working with Sai Charan at Infosys for three years, where we collaborated on the Charles Schwab project. Throughout this time, Sai Charan consistently demonstrated outstanding Mainframe expertise and strong skills in deploying applications on Linux environments. He played a key role in successfully managing the complete tax season, and his technical excellence, reliability, and collaborative spirit made a lasting impact on the project and the team. Sai Charan is not only a highly skilled professional but also a genuinely great colleague to work with.",
      date: "June 2021"
    },
    {
      name: "Gurinder Singh Bains",
      role: "Product Owner at GSK",
      recommendation: "I had the pleasure of working with Charan at GSK for two years, where he was part of my team as a DevOps Engineer. During this time, he played a key role in supporting the cloud migration of an on-prem hosted application as well as deploying and maintaining custom gadgets we developed. Charan’s strong knowledge of Google Cloud Platform (GCP) was instrumental in the success of both projects. He consistently demonstrated a high level of technical expertise, dedication, and attention to detail. Beyond his technical skills, Charan is very approachable and a great team player, always willing to help others and ensure high-quality outcomes. I would highly recommend Charan to any organization looking for a skilled and reliable DevOps Engineer who can deliver results and collaborate effectively.",
      date: "Novemeber 2024"
    },
    {
      name: "Adam Anderson",
      role: "Principal Product Manager at GSK",
      recommendation: "As a product manager accountable for enabling digital and ML investments in functional genomics, I fully appreciate how our teams greatly benefited from Charan's DevSecOps expertise and 'CAN DO' attitude. Charan worked across a number of our digital products spanning on premise and cloud deployments. In particular, Charan was instrumental in the successful rollout of a gene expression analytics tool co-developed with a third party. Not only did he deliver the initial build and deployment automation and enable the upstream data pipelining from our Hadoop cluster, Charan continued to deftly collaborate with our third party partner to routinely deliver to the agreed minor and major release cadence. Along the way, Charan routinely drove solution discovery and implementation to some more challenging technical issues (e.g., load balancing asynchronous requests and migrating our Kubernetes cluster to cloud). Charan would be an excellent addition to any agile effort looking for a positively spirited, outcomes-focused DevSecOps engineer.",
      date: "Novemeber 2024"
    }     
  ],
  display: true // Set false to hide this section, defaults to true
};

// Sections removed

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91 8985623108",
  email_address: "saicharan.sahini@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection,
  linkedinRecommendations
};
